var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34783 1.32144C6.6146 0.7809 7.3854 0.780902 7.65217 1.32144L9.18193 4.42107C9.28786 4.63572 9.49264 4.78449 9.72952 4.81891L13.1502 5.31596C13.7467 5.40264 13.9849 6.13571 13.5532 6.55646L11.078 8.96918C10.9066 9.13626 10.8284 9.37699 10.8689 9.61292L11.4532 13.0197C11.5551 13.6138 10.9315 14.0669 10.3979 13.7864L7.33843 12.1779C7.12656 12.0665 6.87344 12.0665 6.66157 12.1779L3.60206 13.7864C3.06851 14.0669 2.44493 13.6138 2.54683 13.0197L3.13114 9.61292C3.1716 9.37699 3.09339 9.13626 2.92198 8.96918L0.446782 6.55646C0.0151336 6.13571 0.253324 5.40264 0.849848 5.31596L4.27048 4.81891C4.50736 4.78449 4.71214 4.63572 4.81807 4.42107L6.34783 1.32144Z",
    fill: "#FEAF3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.266df2560abdc14ff942868d29dc2542.svg";
export { ForwardRef as ReactComponent };